import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import QRCodeGenerator from './components/QRCodeGenerator/QRCodeGenerator';
import AnalyticsPage from './pages/AnalyticsPage/AnalyticsPage';
import UploadHsFilePage from './pages/UploadHsFilePage/UploadHsFilePage';
import QRCodeListPage from './pages/QRCodeListPage/QRCodeListPage';
import { useAuth } from './hooks/useAuth';
import './App.css';

function App() {
  const { authReady, authError } = useAuth();

  // Wait for the login attempt to complete before rendering API-dependent routes
  if (!authReady) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'Gabarito, sans-serif', color: '#64748b', fontSize: 15 }}>
        Authenticating…
      </div>
    );
  }

  // If authentication failed, show error
  if (authError) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'Gabarito, sans-serif', color: '#ef4444', fontSize: 15, gap: '12px', padding: '20px', textAlign: 'center' }}>
        <div style={{ fontSize: '16px', fontWeight: '700' }}>⚠️ Authentication Failed</div>
        <div style={{ color: '#64748b' }}>You are not authenticated.</div>
        {/* <div style={{ color: '#64748b', fontSize: '13px' }}>Please refresh the page.</div> */}
        {/* <button 
          onClick={() => window.location.reload()} 
          style={{ marginTop: '16px', padding: '8px 16px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}
        >
          Refresh Page
        </button> */}
      </div>
    );
  }

  return (
    <BrowserRouter>
      <div className="app-shell">
        <Routes>
          <Route path="/" element={<Navigate to="/generate" replace />} />
          <Route path="/generate" element={<QRCodeGenerator />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/upload-hs-file" element={<UploadHsFilePage />} />
          <Route path="/qr-list" element={<QRCodeListPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
